export const EventTracker = {
    trackEvent(eventName: string, eventValue: string = '') {
        // console.log('Tracking event:', eventName, eventValue);

        fetch('https://balstats.andwhy.se/event', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                eventName: eventName,
                eventValue: eventValue
            })
        });
    }
};
